import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import data from 'src/assets/states.json';
import { CommonResponseRecords } from 'src/models/commomnModel.model';
import { Vendor } from 'src/models/vendor.model';
import { CommonPagesService } from '../../common-pages.service';
import { responseMessageStatus, ResponseStatus } from '../../enum';
import { first } from 'rxjs';
@Component({
    selector: 'app-add-investor-form',
    templateUrl: './add-investor-form.component.html',
    styleUrls: ['./add-investor-form.component.scss'],
    standalone: false
})
export class AddInvestorFormComponent implements OnInit {
  //#region properties
  listOfStates = data.States;
  isAddingInvestor: boolean = false;
  isVisibleInvestorDrawer = false;
  isAddAddressClicked: boolean = false;
  isInternationalClicked: boolean = false;
  @Input() IsDrawer: boolean = false;
  @Input() ParentCompanyDetails: any;
  @Input() existingReps: any;
  @Output() investorData = new EventEmitter();
  supplierId: string = '';
  supplierDetails = JSON.parse(sessionStorage.getItem('SupplierDetails'));
  userDetails = JSON.parse(localStorage.getItem('UserInfo'));
  programId = this.route.snapshot.queryParamMap.get('programId');

  //#endregion

  //constructor
  constructor(
    public _cS: CommonService,
    public _fS: FormService,
    private route: ActivatedRoute,
    private _cpS: CommonPagesService
  ) {
    _fS.addInvestorForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    this.supplierId = this.route.snapshot.paramMap.get('supplierId');
    this.listOfStates = data.States;
    // if (this.userDetails.localSupplier) {
    this.patchCurrentUserData();
    // }
  }
  patchCurrentUserData() {
    this._fS.addInvestorForm.patchValue({
      firstName: this.userDetails?.firstName || '',
      lastName: this.userDetails?.lastName || '',
      emailAddress: this.userDetails?.email || '',
      phoneNumber: this.userDetails?.phoneNumber || '',
    });
  }
  //add or update button of drawer clicked
  handleOk() {
    if (this._fS.addInvestorForm.valid) {
      this.isAddingInvestor = true;
      const formValue = this._fS.addInvestorForm.value;
      const investorBody = {
        retailProgramId: this.programId,
        companyName: this.supplierDetails?.investorDisplayName.trim(),
        investorDisplayName:
          formValue.firstName.trim() + ' ' + formValue.lastName.trim(),
        email: formValue.emailAddress,
        phoneNumber: formValue.phoneNumber,
        streetAddress1: this.ParentCompanyDetails?.address1?.trim(),
        streetAddress2: this.ParentCompanyDetails?.address2?.trim(),
        city: this.ParentCompanyDetails?.city?.trim(),
        state: this.ParentCompanyDetails?.state?.trim(),
        zipCode: this.ParentCompanyDetails?.zip?.trim(),
        country: this.ParentCompanyDetails?.country?.trim(),
      };

      //add or edit user data
      this.addInvestor(investorBody);
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.addInvestorForm);
    }
  }

  //close drawer
  handleCancel(data: any) {
    this.isVisibleInvestorDrawer = false;
    this.investorData.emit({
      hide: this.isVisibleInvestorDrawer,
      data: data,
    });
  }

  addAddressInvestor(event: boolean) {
    this.isAddAddressClicked = event;
  }

  //add or update data on buttton click
  addInvestor(investorBody: any) {
    this._cpS
      .AddLocalRep(investorBody)
      .subscribe((response: CommonResponseRecords<Vendor>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isAddingInvestor = false;
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
          // hide investor drawer
          this.handleCancel(response.result);
        } else {
          this.isAddingInvestor = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  //#endregion
}
